export interface AbilityDTO {
  id: string; name: string; description?: string; source: string; status: string;
  allowedScope: string; risk: string; requiresConfirmation: boolean; health: string;
  recentSuccessRate: number; recentAttempts: number; version?: number; lastErrorCode?: string;
}
export interface SiteAbilitiesDTO { automatic: AbilityDTO[]; recipes: AbilityDTO[]; api: AbilityDTO[]; mcp: AbilityDTO[] }

const riskLabels: Record<string, string> = { read: "只读", draft: "草稿", write: "写入", sensitive: "敏感", financial: "资金", irreversible: "不可逆" };
const healthLabels: Record<string, string> = { healthy: "健康", degraded: "已降级", probing: "恢复探测", observed: "已发现", disabled: "已停用", unknown: "暂无运行数据" };
export const abilityRiskLabel = (risk: string) => riskLabels[risk] || risk;
export const abilityHealthLabel = (health: string) => healthLabels[health] || health;
export const abilitySuccessRate = (item: AbilityDTO) => item.recentAttempts ? `${Math.round(item.recentSuccessRate * 100)}% · ${item.recentAttempts} 次` : "暂无调用";
export const abilityRiskTone = (risk: string) => risk === "read" ? "green" : risk === "draft" ? "blue" : risk === "write" ? "orange" : "red";
